<div>
  <div class="tittle_sec">
    <h2 mat-dialog-title>{{data?.statusName}}</h2>
    <span (click)="dialogRef.close()" class="close"><mat-icon>clear</mat-icon></span>
  </div>
  <div mat-dialog-content>
    <!-- <h3>{{data?.statusName}}</h3> -->
    <p>{{data?.description}}</p>
  </div>
</div>
